import { ArrowCircleLeft as BackArrow } from '@phosphor-icons/react';

export default BackArrow;